/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { RetrieveCatProviderProfile } from './model/retrieveCatProviderProfile';

export const apiCatProviderProfileRetrieve = (signal?: AbortSignal) => {
  return HTTP<RetrieveCatProviderProfile | void>({
    url: `/api/v7/provider-profile/cat-profile/`,
    method: 'GET',
    signal,
  });
};

export const getApiCatProviderProfileRetrieveQueryKey = () => {
  return [`/api/v7/provider-profile/cat-profile/`] as const;
};

export const getApiCatProviderProfileRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCatProviderProfileRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>> = ({
    signal,
  }) => apiCatProviderProfileRetrieve(signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiCatProviderProfileRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>
>;
export type ApiCatProviderProfileRetrieveQueryError = ErrorType<unknown>;

export function useApiCatProviderProfileRetrieve<
  TData = Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiCatProviderProfileRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiCatProviderProfileRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
